import { useQuery } from '@tanstack/react-query'
import { fetchPartnerComissionTypes } from 'utility/queries/partner'

export const usePartnerComissionTypes = (partnerSlugId) =>
  useQuery({
    queryKey: ['partnerComissionTypes', partnerSlugId],
    queryFn: () => fetchPartnerComissionTypes({ partnerSlugId }),
  })
